import Text from "common/Typography/Text.tsx";
import { typography } from "@shared/common/Themes/typography.ts";
import Link from "common/Typography/Link.tsx";
import { TERMS_OF_USE_LINK } from "@shared/common/constants.ts";
import Form from "common/Form/Form.tsx";
import React from "react";
import Checkbox from "common/Checkbox/Checkbox.tsx";
import styled from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

interface CornixTermsProps {
  initialValue?: boolean;
  onChange?: (checked: boolean) => void;
  termsLink?: string;
}

const CornixTerms = ({
  initialValue,
  onChange,
  termsLink,
}: CornixTermsProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  return (
    <Form.Item
      style={{ marginBottom: 8 }}
      name="cornixAgreement"
      valuePropName="checked"
      initialValue={initialValue}
      rules={[
        {
          validator: (_, value) =>
            value
              ? Promise.resolve()
              : Promise.reject(t("cornix_terms.accept_terms_error")),
        },
      ]}
    >
      <StyledCheckbox onChange={(e) => onChange?.(e.target.checked)}>
        <Text $size={typography.fontSizes.S} style={{ marginLeft: 4 }}>
          {t("cornix_terms.agreement_text")}{" "}
          <Link
            href={termsLink ?? TERMS_OF_USE_LINK}
            target="_blank"
            $size={typography.fontSizes.S}
          >
            {t("cornix_terms.terms_of_use")}
          </Link>
        </Text>
      </StyledCheckbox>
    </Form.Item>
  );
};

export default CornixTerms;

export const StyledCheckbox = styled(Checkbox)<{ $isError?: boolean }>`
  display: flex;
  align-items: center;

  ${(p) =>
    p.$isError &&
    `
    .ant-checkbox-inner {
      border-color: ${p.theme.colors.red};
    }
  `}
  &:hover {
    .ant-checkbox-inner {
      border-color: ${(p) => p.theme.colors.primaryBlue} !important;
    }
  }

  .ant-checkbox {
    top: 0;
  }
`;
